import React from 'react';
import Image from 'next/image';
import ImgLogo from 'assets/icons-static/Logo.svg';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
// import ImgMenu from 'assets/icons-static/Menu.svg';
// import ImgSearch from 'assets/icons-static/Search.svg';
// import ImgNotif from 'assets/icons-static/Notification.svg';
// import ImgHelp from 'assets/icons-static/Help.svg';

import { Avatar, Logo, Button, ListItem } from 'components/atoms';
import { DropdownMenu, Tooltip } from 'components/molecules';
import { UilLeftArrowFromLeft, UilUserCircle } from '@iconscout/react-unicons';
import { getCurrentUser } from 'services/location';

export default function Index({ title }) {
  const router = useRouter();
  const [currentUser, setCurrentUser] = React.useState({});
  const getCurrentUserAPI = () => {
    getCurrentUser().then((res) => {
      if (!res.error) {
        setCurrentUser(res.data.data);
      } else {
        console.log(res);
      }
    });
  };

  const logoutUser = () => {
    Cookies.remove('token');
    Cookies.remove('locationId');
    window.location.href = '/auth/login';
    localStorage.clear();
  };

  React.useEffect(() => {
    getCurrentUserAPI();
  }, []);

  return (
    <nav
      style={{ borderBottom: '1px solid #eaeaea' }}
      className="w-full z-50 fixed top-0 bg-neutral-light flex justify-between items-center p-2 px-3"
    >
      <div className="flex items-center">
        <Image src={ImgLogo} alt="Swing POS" />
        <h3 className="font-bold text-1xl text-gray-davys ml-4">{title}</h3>
      </div>

      <div className="flex items-center">
        {/* <button style={{ marginTop: "0.15rem" }} className="mr-4">
          <Image src={ImgMenu} alt="" />
        </button> */}
        {/* 
        <button className="mr-4 mt-1">
          <Image src={ImgSearch} alt="" />
        </button> */}

        {/* <button className="mr-4 mt-1">
          <Image src={ImgNotif} alt="" />
        </button> */}

        {/* <button className="mr-4 mt-1">
          <Image src={ImgHelp} alt="" />
        </button> */}

        <DropdownMenu content="icon-only" icon={<Avatar name={currentUser?.name} color="#000D23" />} variant="transparent">
          <div className="p-2">
            <ListItem action={() => router.push('/subscription-sales/account')} className="flex items-center">
              <UilUserCircle size="20" />
              <span className="ml-2 whitespace-nowrap">Swing POS Account settings</span>
            </ListItem>
            <ListItem action={logoutUser} className="flex items-center">
              <UilLeftArrowFromLeft size="20" />
              <span className="ml-2 whitespace-nowrap">Log out</span>
            </ListItem>
          </div>
        </DropdownMenu>
      </div>
    </nav>
  );
}
